<template>
  <div class="iframe-container">
    <spinner-round :isLoading="loading"></spinner-round>
    <!-- <div v-if="isCurrent"> -->
    <div>
      <youtube class="iframe-video" v-if="video.provider === 'youtube'" :video-id="videoId" ref="youtube"
             @ready="loading = false"></youtube>
      <vimeo-player class="iframe-video vimeo" v-if="video.provider === 'vimeo'" ref="vimeo" :video-id="videoId"
              @ready="loading = false"></vimeo-player>
    </div>
    <!-- <img v-if="!isCurrent && video.provider === 'youtube'" :src="'http://img.youtube.com/vi/' + videoId + '/0.jpg'" alt="" class="iframe-video">
    <img v-if="!isCurrent && video.provider === 'vimeo'" src="static/plan.png" class="iframe-video"> -->
    <!-- <iframe v-if="video.provider === 'youtube'"
            @load="loading = false"
            :src="'https://www.youtube.com/embed/' + video.video_id + '?enablejsapi=1&version=3&playerapiid=ytplayer'"
            frameborder="0" allow="encrypted-media" allowscriptaccess="always" allowfullscreen
            class="iframe-video"></iframe>
    <iframe v-if="video.provider === 'vimeo'"
            @load="loading = false"
            :src="'https://player.vimeo.com/video/' + video.video_id + '?loop=1&autoplay=1&js_api=1'"
            frameborder="0" allowscriptaccess="always" webkitallowfullscreen mozallowfullscreen allowfullscreen
            class="iframe-video"></iframe> -->
  </div>
</template>

<script>
  export default {
    name: 'VideoExternal',
    data () {
      return {
        loading: true,
        videoId: this.video.video_id,
        isCurrent: false
      }
    },
    props: {
      video: {
        type: Object,
        required: true
      },
      currentSlide: String,
      id: String
    },
    watch: {
      currentSlide (val) {
        if (val !== this.id) {
          this.isCurrent = false
        } else {
          this.isCurrent = true
          this.$nextTick(() => {
            this.playVid()
          })
        }
      }
    },
    computed: {
      player () {
        return this.$refs.youtube.player
      },
      vimeo () {
        return this.$refs.vimeo
      }
    },
    methods: {
      playVid () {
        if (this.video.provider === 'youtube') {
          this.player.playVideo()
        } else {
          this.vimeo.play()
        }
      }
    }
  }
</script>

<style>
  .vimeo iframe {
    height: 100%;
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/utils/VideoExternal.vue